module.exports = __webpack_public_path__ + "img/Group 608.65c38ea5.png";